import React, { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce';

const SFTextboxTypeAnswer = (props) => {

    const [localValue, setLocalValue] = useState(null);
    const [value] = useDebounce(localValue, 500);

    useEffect(() => {
        if (value !== null) {
            props.onAnswerChoice(value);
        }
    }, [value])

    return (
        <div className='w-100' key={props.key}>
            <div className='mb-2'>Fill in the input box:</div>
            <textarea
                className='w-100 px-2 py-2'
                style={{
                    border: "2px solid #A7B1B7",
                    borderRadius: '4px'
                }}
                rows={5}
                defaultValue={props.textValue}
                value={localValue}
                type="text"
                placeholder='Type your answer here'
                name="selectedAnswer"
                onChange={(event) => {
                    let val = event.target.value;
                    setLocalValue(val);
                }}
            />
        </div>
    );
}

export default SFTextboxTypeAnswer;


/* class SFTextboxTypeAnswer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            localValue: "",
        }
    }

    render() {
        return (
            <div className='w-100' key={this.props.key}>
                <div className='mb-2'>Fill in the input box:</div>
                <textarea
                    className='w-100 px-2 py-2'
                    style={{
                        border:"2px solid #A7B1B7",
                        borderRadius:'4px'
                    }}
                    rows={5}
                    value={this.props.compact && this.props.textValue ? this.props.textValue : this.state.localValue}
                    type="text"
                    placeholder='Type your answer here'
                    name="selectedAnswer"
                    onChange={(event) => {
                        this.setState({
                            localValue: event.target.value,
                        })
                        this.props.onAnswerChoice(event.target.value)
                    }}
                />
            </div>
        )
    }
}

export default SFTextboxTypeAnswer; */